export const sharedConfig = {
  maxWaMessageLength: 4000,
  maxWaTemplateLength: 1000,
}